

















import { Component, Vue } from 'vue-property-decorator'
import BasicTopHeader from './top-header.vue'
import helper from '@utils'
// import { Icon as VanIcon } from 'vant'
// import { Popup as VanPopup } from 'vant'
// import { Cell as VanCell, CellGroup as VanCellGroup } from 'vant'
interface Option {
  label: string
  value?: string | number
}
@Component({
  components: {
    BasicTopHeader,
    // VanPopup,
    // VanCell,
    // VanCellGroup,
    // VanIcon
  },
  props: {
    title: {
      type: String,
      default: '??'
    },
    options: {
      type: Array,
      default: () => []
    },
    value: {
      type: [String, Number],
      required: !0
    },
    goBackIsBackMobile: { // 点击左箭头是否跳回移动端,(默认为false)
      type: Boolean,
      default: !1
    }
  }
})
export default class DropDownTopHeader extends Vue {
  private popupIsShow = !1
  private options!: Option[]
  private value!: string | number
  private goBackIsBackMobile!: boolean
  private get cmpSelectedOptionIndex() {
    return this.options.findIndex(ele => {
      if (ele.value) {
        return ele.value === this.value
      } else {
        return ele.label === this.value
      }
    })
  }
  private toggleDropDownList() {
    this.popupIsShow = !this.popupIsShow
  }
  private chosen(option: Option) {
    if (option.value) {
      if (option.value === this.value) {
        return
      }
      this.$emit('input', option.value)
    } else {
      if (option.label === this.value) {
        return
      }
      this.$emit('input', option.label)
    }
    this.popupIsShow = !1
    this.$emit('chosen', option)
  }
  private onClickLeft() {
    this.$emit('go-back')
  }
}
